import type { PortableTextBlock } from 'sanity';

export type PortableTextVariableReplacements = Readonly<Record<string, string>>;

export function substituteVariablesInPortableBlocks(
  blocks: PortableTextBlock[] | undefined | null,
  replacements: PortableTextVariableReplacements,
): PortableTextBlock[] {
  if (!blocks?.length) {
    return [];
  }
  const clone = JSON.parse(JSON.stringify(blocks)) as PortableTextBlock[];
  const sortedEntries = Object.entries(replacements).sort((a, b) => b[0].length - a[0].length);
  if (sortedEntries.length === 0) {
    return clone;
  }

  const applyToText = (text: string): string => {
    let out = text;
    for (const [token, value] of sortedEntries) {
      if (!token || !out.includes(token)) {
        continue;
      }
      out = out.split(token).join(value);
    }
    return out;
  };

  const walk = (node: unknown): void => {
    if (node == null || typeof node !== 'object') {
      return;
    }
    const n = node as Record<string, unknown>;
    if (n._type === 'span' && typeof n.text === 'string') {
      n.text = applyToText(n.text);
      return;
    }
    for (const v of Object.values(n)) {
      if (Array.isArray(v)) {
        v.forEach(walk);
      } else if (v && typeof v === 'object') {
        walk(v);
      }
    }
  };
  clone.forEach(walk);
  return clone;
}
